const PagerPluginLimitation = {
    Init() {
        this.PluginLimitation();
    },
    PluginLimitation() {
        var pageUrl = window.PageData.pageUrl;
        if (typeof pageUrl !== 'undefined' && pageUrl !== null && pageUrl.includes("/strana-") && !pageUrl.includes("/strana-1") && !pageUrl.includes("/tema/")) {
            //$("main.c-content div.c-section:first").hide();
            var contentInner = $(".col-lg-8.c-content-inner");
            if (contentInner.length) {
                contentInner.each(function () {
                    var sectionInners = $(this).find(".c-section-inner");
                    if (sectionInners.length > 1) {
                        sectionInners.hide();
                        sectionInners.slice(-2).fadeIn();
                        sectionInners.each(function () {
                            var articles = $(this).find('article');
                            if (articles.length === 1) {
                                $(this).hide();
                            }
                        });

                    }
                });
            }
        }
    }
};
export default PagerPluginLimitation;